import React from "react";
import { COMPONENT_TYPES } from "../../../../pages/constants/AiAgent";
import { formatMessage } from "../../../../utils/aiagent/aiAgentUtils";
import JobListComponent from "./JobListComponent";
import JobDetailCard from "./JobDetailCard";
import CandidateList from "./CandidateList";
import CandidateDetailCard from "./CandidateDetailCard";
import IndustrySearchBar from "./IndustrySearchBar";
import CompanyFilter from "./CompanyFilter";

const componentMap = {
  [COMPONENT_TYPES.JOB_LIST]: JobListComponent,
  [COMPONENT_TYPES.JOB_DETAIL_CARD]: JobDetailCard,
  [COMPONENT_TYPES.CANDIDATE_LIST]: CandidateList,
  [COMPONENT_TYPES.CANDIDATE_DETAIL_CARD]: CandidateDetailCard,
  [COMPONENT_TYPES.INDUSTRY_SEARCH]: IndustrySearchBar,
  [COMPONENT_TYPES.COMPANY_FILTER]: CompanyFilter,
};

const ComponentRenderer = ({ payload, disabled }) => {
  const { component_type, text } = payload;
  const Component = componentMap[component_type];

  if (!Component) {
    // Graceful degradation: render text as a regular chat message
    if (text) {
      return (
        <p className="text-sm text-gray-700 whitespace-pre-line">
          {formatMessage(text)}
        </p>
      );
    }
    return null;
  }

  return <Component payload={payload} disabled={disabled} />;
};

export default ComponentRenderer;
